import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderValentines = function IconStaticReminderValentines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 39"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.818 2.728v3.636M1 4.545h3.636M11 33.636v3.637m-1.818-1.818h3.636"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.364,
    cy: 0.909,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.091,
    cy: 25.454,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.45 25.384 34.731 7.456m-2.53-.458.29 2.012 1.782.976"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m7.787 23.631.588 1.805 1.484 1.183-3.277.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M19.955 29.053c22.772-13.258 6.326-27.376 0-16.185h-.004c-6.325-11.191-22.772 2.927 0 16.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M10.091 20.457c-6.165-9.649 4.926-16.318 9.86-7.589h.004c6.326-11.191 22.772 2.927 0 16.185h-.004c-2.309-1.345-4.215-2.698-5.769-4.033"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.727,
    cy: 33.637,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.909 12.273c2.273.909 2.273 4.545 0 6.818m-2.495 3.182a24 24 0 0 1-2.535 2.176"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M37.364 20v3.636m-1.819-1.818h3.637"
  }));
};